import { createSelector } from 'reselect'

const getNormalizedContributions = state => state.Discussion.contributions

const getContributionsResult = createSelector(
  [getNormalizedContributions],
  contributions => (!contributions ? null : contributions.result)
)

const getContributions = createSelector(
  [getNormalizedContributions],
  contributions =>
    !contributions ? null : contributions.entities.contributions
)

const getContributionsList = createSelector(
  [getContributionsResult, getContributions],
  (result, contributions) =>
    !result ? null : result.map(id => contributions[id])
)

const getFetchContributionsRequest = state =>
  state.Discussion.fetchDiscussionRequest

const getContribution = (state, id) => getContributions(state)[id]

const getCurrentConclusion = createSelector(
  [getContributionsList],
  contributions =>
    contributions &&
    contributions.filter(
      contribution => contribution.action_object.conclusion
    )[0]
)

const isSibarOpen = state => state.Discussion.sidebar.opened

const getSubmitContributionRequest = state =>
  state.Discussion.submitContributionRequest

const editContributionDialogOpen = state =>
  state.Discussion.editContributionDialog

const getAreTemplatesVisible = state => state.Discussion.templates.visible

const getAreWorksVisible = state => state.Discussion.works.visible

export {
  getContributionsList,
  getContribution,
  getCurrentConclusion,
  getFetchContributionsRequest,
  getSubmitContributionRequest,
  isSibarOpen,
  editContributionDialogOpen,
  getAreTemplatesVisible,
  getAreWorksVisible
}
